
import i18n from "@/plugins/i18n";
import Component, { mixins } from "vue-class-component";
import { ActionMixin } from "../mixins/ActionMixin";
import { Action, State } from "vuex-class";
import { FilterSidebarItem, SidebarRightItem } from "../types";
import { Prop, Watch } from "vue-property-decorator";
import { formatDayMonthYear } from "@/utils/format";
import TagItem from "@/components/TagItem.vue";
import { Event } from "@/types";
import translate from "translate";
@Component({
  components: {
    TagItem,
  },
})
export default class SidebarFilter extends mixins(ActionMixin) {
  @Prop(Object) debate: any;
  @Prop(Object) community: any;
  @Prop(Number) currentLoadingLoungeId: number;
  @Prop(Boolean) disabled: boolean;
  @Prop({ default: false }) toggle: boolean;
  @Prop({ default: true }) showFilter: boolean;
  @Prop({ default: false }) loadingFilter: boolean;
  filterLoungeHeader = {
    svgIcon: "exclusive_lounge",
    name: i18n.t("sidebar.filterLounge"),
    route: "",
  };
  filterEventHeader = {
    svgIcon: "events",
    name: i18n.t("sidebar.filterEvent"),
    route: "",
  };
  debateHeader = {
    svgIcon: "chat",
    name: i18n.t("sidebar.debate"),
    route: "",
  };
  highlightsHeader = {
    svgIcon: "trending_up",
    name: i18n.t("sidebar.highlights"),
    route: "",
  };
  mostActiveUsers = {
    svgIcon: "group_users",
    name: i18n.t("sidebar.mostActiveUsers"),
    route: "",
  };
  relatedDebates = {
    svgIcon: "chat",
    name: i18n.t("sidebar.relatedDebates"),
    route: "",
  };
  aboutLounge = {
    svgIcon: "exclusive_lounge",
    name: i18n.t("community.about"),
    route: "",
  };
  loungeMembers = {
    svgIcon: "group_users",
    name: i18n.t("community.members"),
    route: "",
  };
  suggestedCompanies = {
    svgIcon: "work",
    name: i18n.t("sidebar.suggestedCompanies"),
    route: "",
  };
  drawer = true;
  items: SidebarRightItem | null = null;
  selectedLounges: FilterSidebarItem[] = [];
  selectedEvents: FilterSidebarItem[] = [];
  formatDayMonthYear = formatDayMonthYear;
  loungesFilter: any = [];
  allLounges = false;
  eventsFilter: any = [];
  allEvents = false;
  translatedDebateNames: { [key: number]: string } = {};
  @State((state) => state.profile.me) me: any;
  @State("selectedEvent") selectedEvent: any;
  @State("selectedLounge") selectedLounge: any;
  @Action("timeline/requestSidebarItems") requestSidebarItems: any;
  @Action("updateSelectedLounge") updateSelectedLounge: any;
  @Action("updateSelectedEvent") updateSelectedEvent: any;
  @Action("roundTable/changeUpdateDebate") changeUpdateDebate: any;
  get currentUser(): string {
    return this.debate?.user?.role === "PARTICIPANT"
      ? "avatar-green"
      : this.debate?.user?.role === "EXECUTIVE"
      ? "avatar-red"
      : this.debate?.user?.role === "EQUIPE"
      ? "avatar-black"
      : this.debate?.user?.role === "PARTNER"
      ? "avatar-blue"
      : "company-profile-border";
  }
  get debateLocation(): string {
    return this.debate?.bindedBy === "COMMUNITY"
      ? "exclusive_lounge"
      : this.debate?.bindedBy === "EVENT"
      ? "events"
      : "privacy_public";
  }
  created(): void {
    this.fetchData();
  }
  fetchData(): void {
    this.withLoading(async () => {
      await this.requestSidebarItems().then(async (data: SidebarRightItem) => {
        // Primeiro traduzir todos os debates antes de atribuir ao this.items
        const translatedDebates = [...data.debates];

        // Usar Promise.all para executar todas as traduções em paralelo
        await Promise.all(
          translatedDebates.map(async (item: any) => {
            if (
              item.translation?.translatedName?.originalLanguage !==
              this.$root.$i18n.locale
            ) {
              item.name = item.translation?.translatedName?.contentLanguage
                ? item.translation?.translatedName?.translatedValue
                : await translate(item.name, {
                    to: this.$root.$i18n.locale,
                    from: item.translation?.translatedName?.originalLanguage,
                  });
            }
          })
        );

        // Criar um novo objeto para garantir a reatividade
        this.items = {
          ...data,
          debates: translatedDebates,
        };

        this.loungesFilter.push(data.lounges.slice(0, 4));
        this.eventsFilter.push(data.events.slice(0, 4));
        this.selectedEvents = this.selectedEvent;
        this.selectedLounges = this.selectedLounge;
        this.updateSelectedLounge(this.selectedLounges);
        this.updateSelectedEvent(this.selectedEvents);
      });
    });
  }
  selectItem(item: FilterSidebarItem, type: string): void {
    if (this.loadingFilter) return;
    if (type === "event") {
      if (
        !this.selectedEvents.find(
          (element: FilterSidebarItem) => element.id === item.id
        )
      ) {
        this.selectedEvents.push(item);
      } else {
        this.selectedEvents = this.selectedEvents.filter(
          (element: FilterSidebarItem) => element.id !== item.id
        );
      }
      this.updateSelectedEvent(this.selectedEvents);
    } else {
      if (
        !this.selectedLounges.find(
          (element: FilterSidebarItem) => element.id === item.id
        )
      ) {
        this.selectedLounges.push(item);
      } else {
        this.selectedLounges = this.selectedLounges.filter(
          (element: FilterSidebarItem) => element.id !== item.id
        );
      }
      this.updateSelectedLounge(this.selectedLounges);
    }
  }
  classButton(item: FilterSidebarItem, type: string): string {
    if (type === "event") {
      return this.selectedEvents.find(
        (element: FilterSidebarItem) => element.id === item.id
      )
        ? "purple40 font-weight-bold"
        : "sidebar-filter__border-selected";
    } else {
      return this.selectedLounges.find(
        (element: FilterSidebarItem) => element.id === item.id
      )
        ? "purple40 font-weight-bold"
        : "sidebar-filter__border-selected";
    }
  }
  redirectSearchTag(id: number): void {
    this.$router.push({ name: "searchTagId", params: { id: `${id}` } });
  }
  redirectProfileCompany(id: number): void {
    this.$router.push({ name: "profileMarketing", params: { id: `${id}` } });
  }
  clearFilter(type: string): void {
    if (this.loadingFilter) return;
    if (type === "lounge") {
      this.selectedLounges = [];
      this.updateSelectedLounge(this.selectedLounges);
    } else {
      this.selectedEvents = [];
      this.updateSelectedEvent(this.selectedEvents);
    }
  }
  currentLoungeUser(user: any): string {
    return user.role === "PARTICIPANT"
      ? "avatar-green"
      : user.role === "EXECUTIVE"
      ? "avatar-red"
      : user.role === "EQUIPE"
      ? "avatar-black"
      : user.role === "PARTNER"
      ? "avatar-blue"
      : "company-profile-border";
  }
  getRankingIconName(pos: number): string {
    return pos === 0 ? "1st_place" : pos === 1 ? "2nd_place" : "3rd_place";
  }
  getRankingIconColor(pos: number): string {
    return pos === 0 ? "orangeAlert" : pos === 1 ? "gray70" : "brownRanking";
  }
  currentUserRanking(item: any): string {
    return item.role === "PARTICIPANT"
      ? "avatar-green"
      : item.role === "EXECUTIVE"
      ? "avatar-red"
      : item.role === "EQUIPE"
      ? "avatar-black"
      : item.role === "PARTNER"
      ? "avatar-blue"
      : "company-profile-border";
  }
  redirectDebate(id: number): void {
    if (this.$route.name === "roundTableItems") {
      this.$router.replace({
        name: "roundTableItems",
        params: { id: String(id) },
      });
      this.changeUpdateDebate(true);
    } else {
      this.$router.push({
        name: "roundTableItems",
        params: { id: String(id) },
      });
    }
  }
  nameLocalDebate(): string {
    return this.debate?.bindedBy === "COMMUNITY"
      ? this.debate?.communities?.reduce(
          (string: string, lounge: Event, index: number) => {
            if (index === this.debate?.communities?.length - 1)
              string += String(lounge.name);
            else if (lounge.name) string += lounge.name + ",";
            return string;
          },
          ""
        )
      : this.debate?.bindedBy === "EVENT"
      ? this.debate?.events?.reduce(
          (string: string, event: Event, index: number) => {
            if (index === this.debate?.events?.length - 1)
              string += String(event.name);
            else if (event.name) string += event.name + ",";
            return string;
          },
          ""
        )
      : `${i18n.t("misc.public")}`;
  }
  async nameDebate(item: any): Promise<string> {
    // Se já temos a tradução no cache, retornamos imediatamente
    if (this.translatedDebateNames[item.id]) {
      return this.translatedDebateNames[item.id];
    }

    // Se o idioma do debate é diferente do idioma atual, traduzimos
    if (
      item.translation?.translatedName?.originalLanguage !==
      this.$root.$i18n.locale
    ) {
      try {
        const translatedName = item.translation?.translatedName?.contentLanguage
          ? item.translation?.translatedName?.translatedValue
          : await translate(item.name, {
              to: this.$root.$i18n.locale,
              from: item.translation?.translatedName?.originalLanguage,
            });

        // Usar $set para garantir reatividade ao adicionar nova propriedade
        this.$set(this.translatedDebateNames, item.id, translatedName);
        return translatedName;
      } catch (error) {
        console.error("Erro ao traduzir:", error);
        // Em caso de erro, usamos o nome original
        this.$set(this.translatedDebateNames, item.id, item.name);
        return item.name;
      }
    } else {
      // Se o idioma já é o mesmo, apenas armazenamos no cache
      this.$set(this.translatedDebateNames, item.id, item.name);
      return item.name;
    }
  }

  async translateDebateItem(item: any): Promise<void> {
    // Este método é chamado no template para iniciar a tradução de forma reativa
    if (!item || !item.id || this.translatedDebateNames[item.id]) return;
    // Inicia a tradução e armazena no cache
    await this.nameDebate(item);
    // Força a atualização da interface
    this.$forceUpdate();
  }
  @Watch("toggle", { immediate: true }) onItemChanged(): void {
    if (this.$vuetify.breakpoint.mdAndDown) this.drawer = this.toggle;
  }

  @Watch("$vuetify.breakpoint.lgAndUp") onBreakpointChanged(
    newVal: boolean
  ): void {
    // Fechar drawer para evitar overlay quando redimensiona de lg para md/menor
    if (!newVal) {
      this.drawer = false;
    }
  }

  @Watch("debate", { immediate: true, deep: true })
  onDebateChanged(newValue: any): void {
    if (
      newValue &&
      newValue.relatedDebates &&
      newValue.relatedDebates.length > 0
    ) {
      // Inicializa as traduções para todos os debates relacionados
      this.$nextTick(() => {
        newValue.relatedDebates.forEach((item: any) => {
          this.translateDebateItem(item);
        });
      });
    }
  }
}
